<div class="flex flex-col h-full overflow-hidden">
  <!-- Page Header with Segmented Control -->
  <div class="flex items-center justify-between px-4 pt-4 pb-3 flex-shrink-0 bg-muted">
    <!-- Left: Title -->
    <div class="flex flex-col gap-2">
      <h2 class="text-foreground tracking-tight text-xl-custom font-bold-custom">
        {{'_Dashboard Nhân sự_' | translate}}
      </h2>
    </div>

    <!-- Right: Segmented Control and Menu Button -->
    <div class="flex items-center gap-2">
      <!-- Segmented Control -->
      <div class="flex items-center bg-card border border-border p-1 rounded-lg shadow-sm">
        <button (click)="tabIndex = 0; handleChange(0)" [ngClass]="{
            'bg-primary text-primary-foreground': tabIndex === 0,
            'text-muted-foreground hover:bg-muted': tabIndex !== 0
          }" class="px-3 py-1 rounded-md text-sm font-medium">
          Tổng quan
        </button>
        <button (click)="tabIndex = 1; handleChange(1)" [ngClass]="{
            'bg-primary text-primary-foreground': tabIndex === 1,
            'text-muted-foreground hover:bg-muted': tabIndex !== 1
          }" class="px-3 py-1 rounded-md text-sm font-medium">
          Quy trình
        </button>
      </div>

      <!-- Menu Button -->
      <button type="button"
        class="inline-flex items-center justify-center w-9 h-9 border border-border bg-background rounded-lg shadow-sm transition-all hover:bg-muted">
        <ng-icon name="heroEllipsisVerticalSolid" size="20px" [style.color]="'var(--muted-foreground)'">
        </ng-icon>
      </button>
    </div>
  </div>

  <!-- Main Content Area -->
  <main class="flex-1 overflow-y-auto overflow-x-hidden px-4 pb-4 bg-muted scroll-smooth">
    <div class="w-full flex flex-col gap-3">
      <!-- Conditional Content Based on Selected Tab -->
      <ng-container *ngIf="tabIndex === 1; else dashboardView">
        <!-- Process Accordion View - TODO: Add ProcessAccordion component -->
        <div class="bg-card border border-border p-4 rounded-lg">
          <p class="text-muted-foreground">{{'_Quy trình đang phát triển_' | translate}}</p>
        </div>
      </ng-container>

      <ng-template #dashboardView>
        <!-- Filters -->
        <div class="flex flex-wrap gap-2">
          <div
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-border rounded-full cursor-pointer hover:border-primary/50 transition-colors text-xs font-medium shadow-sm">
            <ng-icon name="heroBuildingOfficeSolid" size="14px" class="text-muted-foreground"></ng-icon>
            <span class="text-foreground">Tất cả phòng ban</span>
            <ng-icon name="heroChevronDownSolid" size="14px" class="text-muted-foreground"></ng-icon>
          </div>
          <div
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-border rounded-full cursor-pointer hover:border-primary/50 transition-colors text-xs font-medium shadow-sm">
            <ng-icon name="heroMapPinSolid" size="14px" class="text-muted-foreground"></ng-icon>
            <span class="text-foreground">Hà Nội</span>
            <ng-icon name="heroChevronDownSolid" size="14px" class="text-muted-foreground"></ng-icon>
          </div>
          <div
            class="inline-flex items-center gap-1.5 px-3 py-1.5 bg-card border border-dashed border-border rounded-full cursor-pointer hover:bg-muted transition-colors hover:text-primary hover:border-primary text-xs font-medium shadow-sm">
            <ng-icon name="heroPlusSolid" size="14px"></ng-icon>
            <span class="text-muted-foreground">Thêm bộ lọc</span>
          </div>
        </div>

        <!-- Main Grid -->
        <div class="grid grid-cols-1 lg:grid-cols-3 gap-3 w-full">
          <!-- Stats Cards - 4 cards in one row -->
          <div class="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:col-span-3">
            <!-- Total Employees Card -->
            <div *ngFor="let tongQuanNhanSu of dashboardData?.tongquan; let i = index"
              class="bg-card p-3 border border-border flex flex-col justify-between hover:border-primary/30 transition-colors cursor-default rounded-lg shadow-sm">
              <div class="flex justify-between items-start">
                <div>
                  <p class="text-muted-foreground text-sm font-medium">{{tongQuanNhanSu?.name | translate}}</p>
                  <h3 class="text-foreground mt-1 text-xl font-bold">{{ tongQuanNhanSu?.tongnv }}</h3>
                </div>
                <span class="p-2 bg-blue-50 text-primary rounded">
                  <ng-icon name="heroUsersSolid" size="20px"></ng-icon>
                </span>
              </div>
              <div class="mt-3 flex items-center gap-2" *ngIf="tongQuanNhanSu?.rateUpDown">
                <span class="flex items-center bg-green-50 px-1.5 py-0.5 text-green-600 text-xs font-medium rounded-md">
                  <ng-icon name="heroArrowTrendingUpSolid" size="12px" class="mr-0.5"></ng-icon>
                  {{ tongQuanNhanSu?.rateUpDown }}
                </span>
                <span class="text-muted-foreground text-xs">so với tháng trước</span>
              </div>
            </div>
          </div>

          <!-- Employee Changes Chart - Takes 2 columns -->
          <div
            class="lg:col-span-2 bg-card border border-border p-4 flex flex-col h-full min-h-[400px] rounded-lg shadow-sm">
            <div class="flex items-center justify-between mb-6">
              <div>
                <h3 class="text-base text-foreground font-bold">
                  {{'_Biến động nhân sự_' | translate}}
                </h3>
                <p class="text-muted-foreground mt-0.5 text-xs">
                  So sánh Tuyển mới vs Nghỉ việc (6 tháng gần nhất)
                </p>
              </div>
            </div>
            <div class="flex-1 flex flex-col gap-2 pt-4 pb-2 relative">
              <div id="legend-bien-dong-nhan-su" *ngIf="dashboardData"></div>
              <canvas style="max-height: 200px; width: 100%" id="bien-dong-nhan-su" *ngIf="dashboardData"></canvas>
            </div>
          </div>

          <!-- Calendar - Takes 1 column -->
          <!-- HR Events Calendar -->
          <div class="lg:col-span-1 bg-card border border-border p-5 flex flex-col h-full rounded-lg shadow-xs">
            <!-- Header with Month Navigation -->
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-foreground text-base font-semibold">
                {{'_Lịch sự kiện nhân sự_' | translate}}
              </h3>
            </div>

            <!-- PrimeNG Datepicker with Custom Styling -->
            <div class="flex flex-col flex-1">
              <p-datepicker [(ngModel)]="dateBirthdays" [inline]="true" class="max-w-full custom-calendar"
                [style]="{'display': 'block'}">

                <!-- Custom Date Template with Event Indicators -->
                <ng-template pTemplate="date" let-date>
                  <div class="relative flex items-center justify-center">
                    <span>{{date.day}}</span>
                    <!-- Event Indicator Dots -->
                    <span *ngIf="birthDays.indexOf(date.day) > -1"
                      class="absolute -bottom-1 left-1/2 -translate-x-1/2 flex gap-1">
                      <span class="w-1.5 h-1.5 rounded-full bg-pink-400" title="Sinh nhật"></span>
                    </span>
                  </div>
                </ng-template>

              </p-datepicker>
            </div>

            <!-- Events Summary Section -->
            <div class="mt-4 border-t border-border pt-4 space-y-3">
              <h4 class="text-foreground text-sm font-medium">Sự kiện trong tháng</h4>

              <!-- Birthday Events -->
              <div class="flex items-center gap-3" *ngIf="dashboardData?.nv_sinhnhat > 0">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                  class="w-4 h-4 text-pink-500 flex-shrink-0">
                  <path
                    d="m15 1.784-.796.795a1.125 1.125 0 1 0 1.591 0L15 1.784ZM12 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L12 1.784ZM9 1.784l-.796.795a1.125 1.125 0 1 0 1.591 0L9 1.784ZM9.75 7.547c.498-.021.998-.035 1.5-.042V6.75a.75.75 0 0 1 1.5 0v.755c.502.007 1.002.021 1.5.042V6.75a.75.75 0 0 1 1.5 0v.88l.307.022c1.55.117 2.693 1.427 2.693 2.946v1.018a62.182 62.182 0 0 0-13.5 0v-1.018c0-1.519 1.143-2.829 2.693-2.946l.307-.022v-.88a.75.75 0 0 1 1.5 0v.797ZM12 12.75c-2.472 0-4.9.184-7.274.54-1.454.217-2.476 1.482-2.476 2.916v.384a4.104 4.104 0 0 1 2.585.364 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 3.67 0 2.605 2.605 0 0 0 2.33 0 4.104 4.104 0 0 1 2.585-.364v-.384c0-1.434-1.022-2.7-2.476-2.917A49.138 49.138 0 0 0 12 12.75ZM21.75 18.131a2.604 2.604 0 0 0-1.915.165 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.605 2.605 0 0 0-2.33 0 4.104 4.104 0 0 1-3.67 0 2.604 2.604 0 0 0-1.915-.165v2.494c0 1.035.84 1.875 1.875 1.875h15.75c1.035 0 1.875-.84 1.875-1.875v-2.494Z">
                  </path>
                </svg>
                <p class="text-foreground text-sm">
                  <span class="font-medium">{{ dashboardData?.nv_sinhnhat }}</span> sinh nhật
                </p>
                <span class="ml-auto text-muted-foreground cursor-pointer hover:text-primary text-xs transition-colors"
                  (click)="viewAllBirthday()">
                  Xem chi tiết
                </span>
              </div>
              <div class="overflow-auto">
                <!-- Employee Avatars -->
                <p-avatarGroup styleClass="mb-3" *ngIf="empBirthDays.length > 0">
                  <ng-container *ngFor="let item of empBirthDays">
                    <p-avatar styleClass="min-w-[45px]" pTooltip="{{item.full_name}} {{item.birthday}}" tooltipPosition="bottom"
                      *ngIf="item?.islink" image="{{item.avatar_url}}" size="large" shape="circle">
                    </p-avatar>
                    <p-avatar  styleClass="min-w-[45px]"pTooltip="{{item.full_name}} {{item.birthday}}" tooltipPosition="bottom"
                      *ngIf="!item?.islink" [label]="item.avatar_url" size="large" shape="circle"
                      [style]="{ 'background-color': '#2196F3', color: '#ffffff' }">
                    </p-avatar>
                  </ng-container>
                </p-avatarGroup>
              </div>
            </div>
          </div>

          <!-- Contract Table - Full width -->
          <div class="lg:col-span-3 bg-card border border-border overflow-hidden flex flex-col rounded-lg shadow-sm">
            <!-- Tabs Header -->
            <div class="px-4 pt-4 pb-0 flex items-center justify-between">
              <p-tabs [(value)]="contractTabIndex" (onChange)="handleContractTabChange($event)">
                <p-tablist class="gap-6">
                  <p-tab [value]="0">
                    <span class="flex items-center gap-2">
                      {{'_Hợp đồng chưa ký_' | translate}}
                      <span
                        class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium rounded-full bg-warning/10 text-warning">
                        {{ dataEmpSignContract?.length || 0 }}
                      </span>
                    </span>
                  </p-tab>
                  <p-tab [value]="1">
                    <span class="flex items-center gap-2">
                      {{'_Sắp hết hạn hợp đồng_' | translate}}
                      <span
                        class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium rounded-full bg-destructive/10 text-destructive">
                        {{ dataEmpContractExp?.length || 0 }}
                      </span>
                    </span>
                  </p-tab>
                  <p-tab [value]="2">
                    <span class="flex items-center gap-2">
                      {{'_Sắp hết hạn bổ nhiệm_' | translate}}
                      <span
                        class="inline-flex items-center justify-center min-w-[20px] h-5 px-1.5 text-xs font-medium rounded-full bg-muted text-muted-foreground">
                        {{ empProcessExpire?.length || 0 }}
                      </span>
                    </span>
                  </p-tab>
                </p-tablist>
              </p-tabs>
              <button (click)="routerExpireContract()"
                class="inline-flex items-center gap-2 text-sm font-medium text-primary hover:text-primary/80 transition-colors">
                <span>{{'_Xem thêm_' | translate}}</span>
                <ng-icon name="heroArrowRightSolid" size="14px"></ng-icon>
              </button>
            </div>

            <!-- Table Content -->
            <div class="flex-1 overflow-hidden">
              <p-tabs [(value)]="contractTabIndex">
                <p-tabpanels>
                  <!-- Tab 0: Hợp đồng chưa ký -->
                  <p-tabpanel [value]="0">
                    <div class="h-[400px] flex flex-col">
                      <app-list-grid-angular *ngIf="empSignContractColumnDef.length > 0 && contractTabIndex === 0"
                        [listsData]="dataEmpSignContract" [height]="400" [columnDefs]="empSignContractColumnDef"
                        [idGrid]="'grid_unsigned_contract'" [rowSelection]="'single'" [checkbox]="false">
                      </app-list-grid-angular>
                      <div class="p-8 text-center flex-1 flex items-center justify-center"
                        *ngIf="empSignContractColumnDef.length === 0 || !dataEmpSignContract || dataEmpSignContract.length < 1">
                        <p class="text-muted-foreground text-sm">{{'_Không có dữ liệu_' | translate}}</p>
                      </div>
                    </div>
                  </p-tabpanel>

                  <!-- Tab 1: Sắp hết hạn hợp đồng -->
                  <p-tabpanel [value]="1">
                    <div class="h-[400px] flex flex-col">
                      <app-list-grid-angular *ngIf="empContractExpColumnDef.length > 0 && contractTabIndex === 1"
                        [listsData]="listDataView" [height]="400" [columnDefs]="empContractExpColumnDef"
                        [idGrid]="'grid_expiring_contract'" [rowSelection]="'single'" [checkbox]="false">
                      </app-list-grid-angular>
                      <div class="p-8 text-center flex-1 flex items-center justify-center"
                        *ngIf="empContractExpColumnDef.length === 0 || !listDataView || listDataView.length < 1">
                        <p class="text-muted-foreground text-sm">{{'_Không có dữ liệu_' | translate}}</p>
                      </div>
                    </div>
                  </p-tabpanel>

                  <!-- Tab 2: Sắp hết hạn bổ nhiệm -->
                  <p-tabpanel [value]="2">
                    <div class="h-[400px] flex flex-col">
                      <app-list-grid-angular
                        *ngIf="empProcessExpireColumnDef && empProcessExpireColumnDef.length > 0 && contractTabIndex === 2"
                        [listsData]="empProcessExpire" [height]="400" [columnDefs]="empProcessExpireColumnDef"
                        [idGrid]="'grid_appointment_expire'" [rowSelection]="'single'">
                      </app-list-grid-angular>
                      <div class="p-8 text-center flex-1 flex items-center justify-center"
                        *ngIf="!empProcessExpireColumnDef || empProcessExpireColumnDef.length === 0 || !empProcessExpire || empProcessExpire.length < 1">
                        <p class="text-muted-foreground text-sm">{{'_Không có dữ liệu_' | translate}}</p>
                      </div>
                    </div>
                  </p-tabpanel>
                </p-tabpanels>
              </p-tabs>
            </div>

            <!-- Pagination Footer -->
            <div class="px-4 py-2 border-t border-border bg-card flex items-center justify-between flex-shrink-0">
              <span class="text-muted-foreground text-sm">
                <ng-container [ngSwitch]="contractTabIndex">
                  <ng-container *ngSwitchCase="0">
                    Hiển thị 1 - {{ dataEmpSignContract?.length || 0 }} trên {{ dataEmpSignContract?.length || 0 }} kết
                    quả
                  </ng-container>
                  <ng-container *ngSwitchCase="1">
                    Hiển thị 1 - {{ listDataView?.length || 0 }} trên {{ listDataView?.length || 0 }} kết quả
                  </ng-container>
                  <ng-container *ngSwitchCase="2">
                    Hiển thị 1 - {{ empProcessExpire?.length || 0 }} trên {{ empProcessExpire?.length || 0 }} kết quả
                  </ng-container>
                </ng-container>
              </span>
              <div class="flex items-center gap-2">
                <button
                  class="inline-flex items-center justify-center w-8 h-8 border border-border rounded hover:bg-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled>
                  <ng-icon name="heroChevronLeftSolid" size="16px" class="text-muted-foreground"></ng-icon>
                </button>
                <span class="px-3 py-1 text-sm font-medium">1</span>
                <button
                  class="inline-flex items-center justify-center w-8 h-8 border border-border rounded hover:bg-muted transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled>
                  <ng-icon name="heroChevronRightSolid" size="16px" class="text-muted-foreground"></ng-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
  </main>
</div>

<!--  <div class="grid boxs pb-6">-->
<!--    <div class="col-3 md:col-12 lg:col-3 xl:col-3">-->
<!--    </div>-->
<!--    <div class="col-6 md:col-12 lg:col-6 xl:col-6">-->
<!--      <div id="funnel"></div>-->
<!--    </div>-->
<!--    <div class="col-3 md:col-12 lg:col-3 xl:col-3">-->
<!--    </div>-->
<!--  </div>-->




<p-drawer styleClass="hr-diagram" [style]="{ width: '70% !important' }" blockScroll="flase" autoBlockScroll
  [(visible)]="isHrDiagram" position="right">
  <ng-template pTemplate="header">
    <!-- #iconheader --></ng-template>
  <ng-template pTemplate="footer"></ng-template>
  <p-organizationChart [value]="listAgencyMap" #mydiv [preserveSpace]="false" selectionMode="single"
    [(selection)]="selectedNode" (onNodeSelect)="onNodeSelect($event)" styleClass="company">
    <ng-template let-node pTemplate="person">
      <div class="node-header p-corner-top">{{node.data.position ? node.data.position : 'No position'}}</div>
      <div class="node-content">
        <img src="{{node.data.avatarUrl ? node.data.avatarUrl : '../../../../../assets/images/img_avatar.png'}}"
          width="32">
        <div>{{node.data.full_name ? node.data.full_name : 'No name'}}</div>
      </div>
    </ng-template>
    <ng-template let-node pTemplate="department">
      {{node.label}}
    </ng-template>

  </p-organizationChart>
</p-drawer>